module.exports = __webpack_public_path__ + "static/media/sample-of-cert-for-ALUZINC.be15a372.jpg";